import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import close from '../../../assets/img/icons/close.svg'
import silver from '../../../assets/img/premium/silver.svg'
import gold from '../../../assets/img/premium/gold.svg'
import blue from '../../../assets/img/premium/blue.svg'
import SelectPlan from './selectplan';
import PaymentPending from '../../main/plan/paymentpending';
import axios from 'axios';
import { Trans } from "react-i18next";   
import "../../../config/i18n";
import { withTranslation } from "react-i18next";

class Join extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOptions: {
                silver: false,
                gold: false,
                platinum: false,
            },
            selectplanmodal: false,
            paymentpendingmodal: false,
            api_url:localStorage.getItem('api_url'),
        };
    }

    componentDidMount(){
        var datalist = new FormData();   
        datalist.set('user_id',JSON.parse(localStorage.getItem('session_userid'))); 
        datalist.set('language', 'en');
        axios({
            method: 'post',
            url: this.state.api_url+'webprofile',
            data: datalist,    
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            if(res.data.status === 'true') {
                const user_details = res.data.result;
                this.setState({
                    user_details: user_details,
                });
            }
        });
    }

    toggleOption = (option, row) => {
        if (row === 'premium') {
            const updatedOptions = { ...this.state.selectedOptions };
            ['silver', 'gold', 'platinum'].forEach(key => {
                updatedOptions[key] = false;
            });
            updatedOptions[option] = true;
            this.setState({
                selectedOptions: updatedOptions,
                premiumType: option
            });
        } else {
            console.log('checking')
        }
    };

    handleSelectPlanOpenModal = () => {
        if(this.state.user_details.premium_cashpayment === 'true') {
            this.props.handleClose();
            this.handlePaymentPendingOpenModal();
        } else {
            localStorage.setItem('premium_type', this.state.premiumType);
            this.props.handleClose();
            this.setState({ selectplanmodal: true });
        }
    }

    handleSelectPlanCloseModal = () => {
        this.setState({ selectplanmodal: false });
    }

    handlePaymentPendingOpenModal = () => {
        this.setState({ paymentpendingmodal: true });
    }

    handlePaymentPendingCloseModal = () => {
        this.setState({ paymentpendingmodal: false });
    }

    render() {
        const { selectedOptions } = this.state;
        return (
            <>
                <div className="">
                    <Modal className="modal_div joinplan_modal" show={this.props.showModal} onHide={this.props.handleClose} centered>
                        <Modal.Header>
                            <Modal.Title><Trans i18nKey="Join Kaba Premium">Join Kaba Premium</Trans></Modal.Title>
                            <Button className="close" onClick={this.props.handleClose}>
                                <img src={close} alt="img" />
                            </Button>
                        </Modal.Header>
                        <Modal.Body className="religion_modal">
                            <div className='Joinpremium_div'>
                                <div className='Joinpremium_subdiv'>
                                    <div className={`premium_div ${selectedOptions.silver ? 'premiumselect' : ''}`} onClick={() => this.toggleOption('silver', 'premium')}>
                                        <div className='premium_subdiv'>
                                            <img src={silver} alt="img" />
                                            <h4><Trans i18nKey="Kaba Silver">Kaba Silver</Trans></h4>
                                        </div>
                                    </div>
                                    <div className={`premium_div ${selectedOptions.gold ? 'premiumselect' : ''}`} onClick={() => this.toggleOption('gold', 'premium')}>
                                        <div className='premium_subdiv'>
                                            <img src={gold} alt="img" />
                                            <h4><Trans i18nKey="Kaba Gold">Kaba Gold</Trans></h4>
                                        </div>
                                    </div>
                                    <div className={`premium_div ${selectedOptions.platinum ? 'premiumselect' : ''}`} onClick={() => this.toggleOption('platinum', 'premium')}>
                                        <div className='premium_subdiv'>
                                            <img src={blue} alt="img" />
                                            <h4><Trans i18nKey="Kaba Platinum">Kaba Platinum</Trans></h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer className="forgot_button_plr">
                            <Button className='button_primary' onClick={this.handleSelectPlanOpenModal}>
                                <Trans i18nKey="Join">Join</Trans>
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>

                <SelectPlan
                    showModal={this.state.selectplanmodal}
                    handleClose={this.handleSelectPlanCloseModal}
                    premiumType={this.state.premiumType}
                />

                <PaymentPending
                    showModal={this.state.paymentpendingmodal}
                    handleClose={this.handlePaymentPendingCloseModal}
                />
            </>
        );
    }
}

export default Join;
